'use client';
import { useEffect, useMemo } from 'react';
import { CatDropdown } from '@blocks-react/components/Dropdown';
import { CatList } from '@blocks-react/components/List';
import { CatListItem } from '@blocks-react/components/ListItem';
import { useDropdownController } from '@cat-ecom/pcc-components/src/hooks/form-controllers';
import { useFormContext } from 'react-hook-form';
import FormInput from './Guest-Input-Form-Text';
import { FORM_NAMES } from '../constants';
import { CountryType, FormPhoneInputProps } from './types';
import cx from 'classnames';
import styles from './Guest-Phone-Input.module.scss';
const FormPhoneInput = ({
  disabled = false,
  countries,
  phoneError,
  phoneRule,
  dropdownLabel = '',
  inputLabel,
  fieldNote = '',
  required,
  t
}: FormPhoneInputProps) => {
  const form = useFormContext();

  const { dropdownField } = useDropdownController({
    name: FORM_NAMES.COUNTRY_CODE
  });

  const onChangeDropdown = (e) => {
    const selectedCountryCode = e?.detail.value;
    form.setValue(FORM_NAMES.COUNTRY_CODE, selectedCountryCode);
  };

  const sortedCountries = useMemo(
    () =>
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (countries as any)?.toSorted((a: CountryType, b: CountryType) => {
        if (a?.code < b?.code) {
          return -1;
        } else if (b?.code > a?.code) {
          return 1;
        }

        return 0;
      }) as CountryType[],
    [countries]
  );

  return (
    <div className={cx(styles['phone-input__container'], 'd-flex w-100')}>
      <div className={cx(styles['dropdown-container'])}>
        <CatDropdown
          {...dropdownField}
          notation={
            required
              ? t('REQUIRED_FIELD_MESSAGE')
              : (t('OPTIONAL') || '').toLowerCase()
          }
          disabled={disabled}
          ariaDescribedBy="country-code-dropdown"
          fieldId="country-code"
          label={dropdownLabel}
          errorNote={fieldNote}
          onBlSelect={(e) => {
            onChangeDropdown(e);
          }}
          position="bottom-start"
        >
          <div>
            <CatList>
              {sortedCountries?.map(
                ({ code, callingCode }) =>
                  !!callingCode && (
                    <CatListItem key={code} value={code}>
                      {code} {callingCode}
                    </CatListItem>
                  )
              )}
            </CatList>
          </div>
        </CatDropdown>
      </div>

      <div className={cx(styles['input-container'])}>
        <FormInput
          disabled={disabled}
          name={FORM_NAMES.PHONE}
          label={inputLabel}
          maxlength={16}
          required
          error={phoneError}
          rules={phoneRule}
          t={t}
        />
      </div>
    </div>
  );
};

export default FormPhoneInput;
